import { supabase } from "../supabaseClient";

const acceptBets = async (betId, callback) => {
  try {
    // Update the bet status in the Supabase database
    const { data, error } = await supabase
      .from("bets")
      .update({ betstatus: "active" })
      .eq("betid", betId);

    if (error) {
      console.error("Error updating bet status:", error);
      alert("There was an error accepting the bet. Please try again.");
      return;
    }

    // Optionally, you can fetch the updated bet to verify the update
    const { data: updatedBet, error: fetchError } = await supabase
      .from("bets")
      .select("*")
      .eq("betid", betId)
      .single();

    if (fetchError) {
      console.error("Error fetching updated bet:", fetchError);
      alert("There was an error fetching the updated bet. Please try again.");
      return;
    }

    // Call the callback function if provided
    if (callback) {
      callback();
    }

    alert("Bet accepted successfully!");
  } catch (error) {
    console.error("Unexpected error accepting bet:", error);
    alert("There was an unexpected error. Please try again.");
  }
};

// Keep removed bets in the database so they remain available in bet history.
const deleteBets = async (betId, callback) => {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  const authUser = sessionData?.session?.user;

  if (sessionError || !authUser) {
    console.error("Unable to identify the user withdrawing this bet:", sessionError);
    alert("Please sign in again before withdrawing this bet.");
    return;
  }

  const { data: userData, error: userError } = await supabase
    .from("users")
    .select("username")
    .eq("public_user_id", authUser.id)
    .maybeSingle();

  if (userError) {
    console.error("Unable to load the withdrawing user's name:", userError);
    alert("There was an error withdrawing the bet. Please try again.");
    return;
  }

  const { error } = await supabase
    .from("bets")
    .update({
      betstatus: "withdrawn",
      withdrawn_at: new Date().toISOString(),
      withdrawn_by: authUser.id,
      withdrawn_by_name: userData?.username || "Unknown user",
    })
    .eq("betid", betId);

  if (error) {
    console.error("Error withdrawing bet:", error);
    if (error.code === "PGRST204") {
      alert("Bet history has not been enabled in the database yet. Apply the bet history migration, then try again.");
    } else {
      alert("There was an error withdrawing the bet. Please try again.");
    }
    return;
  }

  if (callback) {
    callback();
  }
};

const archiveBet = async (betId, callback) => {
  const { error } = await supabase
    .from("bets")
    .update({ betstatus: "archived" })
    .eq("betid", betId);

  if (error) {
    console.error("Error archiving settled bet:", error);
    alert("There was an error removing this bet from Settled. Please try again.");
    return;
  }

  if (callback) callback();
};

export { acceptBets, deleteBets, archiveBet };
